var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigmaSettingsDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-setting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3474 5.83311C16.2184 5.29461 15.5381 5.11386 15.1466 5.50536C14.2054 6.44661 13.1569 7.49511 12.9506 7.70136C12.1736 8.47836 10.8829 8.43111 10.1689 7.55736C9.54787 6.79836 9.68062 5.66736 10.3744 4.97361L12.4939 2.85411C12.8854 2.46261 12.7054 1.78161 12.1669 1.65261C11.3824 1.46436 10.5341 1.44186 9.65512 1.63236C7.47187 2.10636 5.73187 3.89436 5.34112 6.09411C5.16562 7.08261 5.25037 8.03436 5.53537 8.89461L2.24137 12.1789C1.25288 13.1674 1.25288 14.7701 2.24137 15.7586C3.22987 16.7471 4.83262 16.7471 5.82112 15.7586L9.11962 12.4699C9.97612 12.7511 10.9226 12.8329 11.9051 12.6581C14.1056 12.2674 15.8936 10.5281 16.3669 8.34411C16.5581 7.46511 16.5349 6.61761 16.3474 5.83311Z",
    fill: "url(#paint0_linear_9146_76391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.125 15C4.74632 15 5.25 14.4963 5.25 13.875C5.25 13.2537 4.74632 12.75 4.125 12.75C3.50368 12.75 3 13.2537 3 13.875C3 14.4963 3.50368 15 4.125 15Z",
    fill: "url(#paint1_linear_9146_76391)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9146_76391",
    x1: -6.69978,
    y1: 4.15193,
    x2: 13.4832,
    y2: 21.1574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#B9C9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9146_76391",
    x1: 4.125,
    y1: 12.75,
    x2: 4.125,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaSettingsDark);
export default __webpack_public_path__ + "static/media/figma-settings-dark.ebb8a25a01b475cbd6bd1d865bb0bd8a.svg";
export { ForwardRef as ReactComponent };